// extracted by mini-css-extract-plugin
export var container = "pricelist-module--container--3D6Bm";
export var headline = "pricelist-module--headline--2qDWA";
export var title = "pricelist-module--title--2J5JK";
export var service = "pricelist-module--service--362oF";
export var pricelist = "pricelist-module--pricelist--3LJ44";
export var pricelistItem = "pricelist-module--pricelistItem--2szWr";
export var procedureTitle = "pricelist-module--procedureTitle--32Km9";
export var procedure = "pricelist-module--procedure--45_25";
export var price = "pricelist-module--price--fvLi1";